import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CollegeUniversityIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CollegeUniversityIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 15.0366C11.9272 15.0366 11.8545 15.021 11.7871 14.9888L2.28711 10.5151C2.11182 10.4331 2 10.2563 2 10.063C2 9.86963 2.11182 9.69286 2.28711 9.61083L11.7871 5.1372C11.9219 5.07275 12.0781 5.07275 12.2129 5.1372L21.7129 9.61083C21.8882 9.69286 22 9.86963 22 10.063C22 10.2563 21.8882 10.4331 21.7129 10.5151L12.2129 14.9888C12.1455 15.021 12.0728 15.0366 12 15.0366ZM3.67383 10.063L12 13.9839L20.3262 10.063L12 6.14208L3.67383 10.063Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0737 12.2856C18.0059 12.2856 17.937 12.272 17.8711 12.2427L12.7573 9.96825C12.5049 9.85595 12.3916 9.56005 12.5034 9.30809C12.6162 9.05614 12.9121 8.94286 13.1636 9.05418L18.2773 11.3286C18.5298 11.4409 18.6431 11.7368 18.5312 11.9888C18.4482 12.1753 18.2656 12.2856 18.0737 12.2856Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4814 18.9097H16.6665C16.3901 18.9097 16.1665 18.686 16.1665 18.4097V15.2876C16.1665 15.103 16.2681 14.9331 16.4312 14.8462L17.8389 14.0952C17.9863 14.0171 18.1621 14.0171 18.3096 14.0952L19.7168 14.8462C19.8799 14.9331 19.9814 15.103 19.9814 15.2876V18.4097C19.9814 18.686 19.7578 18.9097 19.4814 18.9097ZM17.1665 17.9097H18.9814V15.5874L18.0742 15.103L17.1665 15.5874V17.9097Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0254 18.3726C8.85059 18.3726 5.47607 17.354 5.47607 15.4653V11.7856C5.47607 11.5093 5.6997 11.2856 5.97607 11.2856C6.25244 11.2856 6.47607 11.5093 6.47607 11.7856V15.4653C6.47607 16.2622 8.5874 17.3726 12.0254 17.3726C13.5044 17.3726 14.9092 17.1538 15.9814 16.7554C16.2388 16.6606 16.5278 16.7905 16.624 17.0503C16.7202 17.3091 16.5884 17.5972 16.3291 17.6929C15.1489 18.1313 13.6201 18.3726 12.0254 18.3726Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0742 15.0366C17.7978 15.0366 17.5742 14.813 17.5742 14.5366V11.7856C17.5742 11.5093 17.7978 11.2856 18.0742 11.2856C18.3506 11.2856 18.5742 11.5093 18.5742 11.7856V14.5366C18.5742 14.813 18.3506 15.0366 18.0742 15.0366Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CollegeUniversityIcon;
